import React from 'react'

import styled from '@emotion/styled'
import { LBL_ALIAS_STATUS } from 'Constants/'
import { modalSmsSenderState } from 'Hooks/useModalSmsSender/useModalSmsSender'
import { getLang } from 'mailup-react-helpers'
import {
  Badge,
  BADGE_KIND_SECONDARY,
  BADGE_TYPE_DEFAULT,
  Divider,
  Flex,
  FlexItem,
  HelpIcon,
  RadioButton,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const StyledTable = styled(Flex)`
  border: 1px solid var(--geyser);

  .modal-sms-sender__radio-button-label {
    font-weight: 500;
    color: var(--boulder);
  }
`

const SmsAliasTable = ({ isTrial, items, caseState }) => {
  const intl = useIntl()
  const lang = getLang()
  const [{ selectedAlias }, setSelectedAlias] =
    useRecoilState(modalSmsSenderState)

  const getItem = (e) => {
    let ret
    if (e.Status === 0) {
      ret = LBL_ALIAS_STATUS.find(
        (item) =>
          item.key === e.Status &&
          item.IsTraceableToCompanyName === !!e.IsTraceableToCompanyName
      )
    } else {
      ret = LBL_ALIAS_STATUS.find((item) => item.key === e.Status)
    }
    return ret
  }

  const getBadgeText = (e) => {
    const ret = getItem(e)
    return ret ? ret.value : ''
  }

  const getBadgeType = (e) => {
    const ret = getItem(e)
    return ret ? ret.type : BADGE_TYPE_DEFAULT
  }

  const handleHelp = () => {
    if (lang === 'it') {
      window.open(
        'https://helpmailup.atlassian.net/wiki/spaces/MM/pages/37814278/Mittenti+testuali+stati+e+cause+rifiuto',
        '_blank',
        'noopener,noreferrer'
      )
    } else if (lang === 'es') {
      window.open(
        'https://helpmailup.atlassian.net/wiki/spaces/MMES/pages/38338566/Nombres+de+remitentes+personalizados+estado+y+motivos+del+rechazo',
        '_blank',
        'noopener,noreferrer'
      )
    } else {
      window.open(
        'https://helpmailup.atlassian.net/wiki/spaces/MUG/pages/38338641/Custom+SMS+sender+names+-+Status+and+reasons+for+refusal',
        '_blank',
        'noopener,noreferrer'
      )
    }
  }

  return (
    <>
      <Flex gap='4px'>
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({
            id: 'Load.SmsAliasSelector.ModalSenderTitleTableAlias'
          })}
        </Title>
      </Flex>
      <StyledTable width='100%' flexDirection='column'>
        {items
          .filter((e) => e.Status !== 9)
          .map((e, index) => (
            <React.Fragment key={e.Id}>
              <Flex height='60px' alignItems='center'>
                <FlexItem flexBasis='33%' padding='0 0 0 8px'>
                  <RadioButton
                    labelClassName='modal-sms-sender__radio-button-label'
                    value={e.Id}
                    checked={selectedAlias && selectedAlias.Id === e.Id}
                    label={`${e.Alias}`}
                    onChange={() => {
                      setSelectedAlias((prev) => ({
                        ...prev,
                        selectedAlias: e
                      }))
                    }}
                    data-mu-test={`modal-sms-sender-radio-${e.Id}`}
                  />
                </FlexItem>
                <Flex
                  alignItems='center'
                  justifyContent='flex-end'
                  gap='4px'
                  flexBasis='66%'
                >
                  <Badge
                    type={getBadgeType(e)}
                    kind={BADGE_KIND_SECONDARY}
                    text={intl.formatMessage({
                      id: getBadgeText(e)
                    })}
                  />

                  <span onClick={handleHelp}>
                    <HelpIcon />
                  </span>
                </Flex>
              </Flex>
              {index < items.length - 1 && <Divider />}
            </React.Fragment>
          ))}
      </StyledTable>
    </>
  )
}

SmsAliasTable.propTypes = {
  isTrial: PropTypes.bool,
  items: PropTypes.array,
  caseState: PropTypes.number
}

export default SmsAliasTable
